"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindMemberDay = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var bindClient_1 = require("../../model/bindClient");
var service_1 = require("../../../library/base/service");
var BindMemberDay = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BindMemberDay, _super);
    function BindMemberDay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '用户会员日活动绑定';
        _this.code = '300431';
        _this.desc = '用户会员日活动绑定';
        _this.requestParams = new bindClient_1.BindRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return BindMemberDay;
}(service_1.BaseService));
exports.BindMemberDay = BindMemberDay;
//# sourceMappingURL=bindMemberDay.js.map